import axios from 'axios';

// Send shipment lead to relay endpoint (serverless function)
export const sendShipmentToSlack = async (formData) => {
  const relayUrl = process.env.REACT_APP_SLACK_RELAY_URL;
  if (!relayUrl) {
    return { success: false, error: 'Slack relay URL not configured.' };
  }

  const slackMessage = {
    text: `New Shipment Lead:\n\n*Pickup Location:* ${formData.pickup_location}\n*Dropoff Location:* ${formData.dropoff_location}\n*Pickup Date:* ${formData.book_pick_date}\n*Email:* ${formData.email_address}\n*Phone:* ${formData.phone_number}\n*Consent Transactional:* ${formData.consentTransactional ? 'Yes' : 'No'}\n*Consent Marketing:* ${formData.consentMarketing ? 'Yes' : 'No'}\n*Consent Terms:* ${formData.consentTerms ? 'Yes' : 'No'}`
  };

  try {
    const response = await axios.post(relayUrl, slackMessage, {
      headers: { 'Content-Type': 'application/json' },
    });
    return { success: true, response };
  } catch (error) {
    return { success: false, error };
  }
};
